<template>
  <div :key="index">
    <div :style="
    'text-align: '+options.data.pageCss.alignment+';padding:' + options.data.pageCss.page_css_padding + 
    ';margin:' + options.data.pageCss.page_css_margin + 
    ';border-radius:' + options.data.pageCss.page_css_radius + 
    'px;background-color:' + options.data.pageCss.textBgc+';'+options.data.pageCss.myCss">
      <div ref="thanks" class="mapBox">
        <div class="map_container" :id="'map_container'+index"></div>
      </div>
    </div>

    <slot></slot>
  </div>

</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "mapBox",
  props: ["index"],
  data() {
    return {
      map_laber: null,
      marker: null,
      map_container: null
    };
  },
  computed: {
    ...mapGetters(["okForm"]),
    ...mapGetters(["workPlace"]),
    options() {
      let data = this.okForm[this.index]
        ? this.okForm[this.index].options
        : { data: this.workPlace.pageTitle.data };
      return data;
    },
  },
  watch: {
    options: {
      handler(newValue, oldValue) {
        console.log(newValue);
        // 当 options 发生变化时，更新地图
        if (newValue.data.lat && newValue.data.lng) {
          this.updateMapPosition(newValue.data.lat, newValue.data.lng);
        }
      },
      deep: true,  // 深度监听，确保对象内的变化也能被检测到
    },
  },
  created() {
    console.log(this.okForm);
  },
  mounted() {
    this.createMap();
  },
  methods: {

    updateMapPosition(lat, lng) {
      if (this.map_container) {
        // 更新地图中心
        console.log("Updating map position to:", lat, lng);
        this.map_container.setCenter(new qq.maps.LatLng(lat, lng));
      }
      if (this.marker) {
        // 更新标记位置
        this.marker.setPosition(new qq.maps.LatLng(lat, lng));
      }
      if (this.map_laber) {
        this.map_laber.setContent(this.options.data.db); // 更新标签的文字
        const textLength = this.options.data.db.length | 0; // 文字字数
        const fontSize = 16;
        const offsetX = -(textLength * fontSize) / 2;
        const offsetY = -65;
        this.map_laber.setOffset(new qq.maps.Size(offsetX, offsetY));  // 更新标签的偏移量
      }
    },
    createMap() {
      let _this = this;
      var defaultLatLng
      if (_this.options.data.lat && _this.options.data.lng) {
        defaultLatLng = new qq.maps.LatLng(_this.options.data.lat, _this.options.data.lng);
      } else {
        // 默认位置：东方明珠
        defaultLatLng = new qq.maps.LatLng(31.2397, 121.5007);  // 东方明珠的位置
      }
      // 初始化地图
      this.map_container = new qq.maps.Map(document.getElementById("map_container" + this.index), {
        center: defaultLatLng,  // 设置地图中心为东方明珠
        zoom: 15  // 设置地图缩放级别
      });

      // 创建一个自定义图标的标记
      var customIcon = new qq.maps.MarkerImage(
        'https://www.cndmcloud.com/storage/setmeet/2025-06/83jyCkUBGttegKWUAGhrKEabyTlsIevMJ6G0Vn26.png',  // 自定义图标的URL
        new qq.maps.Size(40, 40),  // 设置图标的大小（宽，高）
        new qq.maps.Point(0, 0),  // 设置图标的偏移量（通常设为 (0,0) 即左上角）
        new qq.maps.Point(20, 40)  // 设置标记的锚点（通常为图标底部中间点）
      );


      // 创建一个使用自定义图标的标记
      this.marker = new qq.maps.Marker({
        position: defaultLatLng,
        map: this.map_container,
        icon: customIcon  // 设置标记图标为自定义图标
      });

      const textLength = _this.options.data.db.length | 0; // 文字字数
      const fontSize = 16;
      const offsetX = -(textLength * fontSize) / 2;
      const offsetY = -65;


      // 红色文字标签
      this.map_laber = new qq.maps.Label({
        position: defaultLatLng,
        map: this.map_container,
        content: _this.options.data.db, // 文字字数,
        offset: new qq.maps.Size(offsetX, offsetY)
      });

      this.map_laber.setStyle({
        color: "#000",
        fontSize: "16px",
        fontWeight: "bold",
        backgroundColor: 'transparent',
        border: 'none',
      });

      // 创建一个默认标记
      // var marker = new qq.maps.Marker({
      //   position: defaultLatLng,
      //   map: map
      // });

      // 点击地图时获取经纬度并添加标记
      qq.maps.event.addListener(this.map_container, 'click', function (event) {
        return
        var lat = event.latLng.getLat();  // 获取纬度
        var lng = event.latLng.getLng();  // 获取经度

        // 显示经纬度
        _this.options.data.lat = lat;
        _this.options.data.lng = lng;

        // 更新动态标记位置
        marker.setPosition(event.latLng);
      });

    }
  },
};
</script>

<style lang="less" scoped>
.jiugonggeBox {
  overflow: hidden;
}
.mapBox {
  width: 100%;
  aspect-ratio: 16 / 9;
  .map_container {
    width: 100%;
    height: 100%;
  }
}
@keyframes suhbar {
  0% {
    background-position: 780px 0;
  }

  100% {
    background-position: 0 0;
  }
}
</style>